import styles from '@features/categories/components/CategoriesSelectedFilters/CategoriesSelectedFilters.styles';
import Icon from '@components/icons/Icon';
import theme from '@styles/theme';
import Button from '@components/Button/Button';
import Close2 from '@components/icons/components/Close2';
type PropsType = {
  label: string;
  onResetClick: () => void;
};
const CategoriesFilterChip = ({
  label,
  onResetClick
}: PropsType) => <span sx={styles.chip}>
    {label}
    <Button variant="iconOnly" onClick={onResetClick}>
      <Icon size="14px" margin="0 0 0 8px" color={theme.rawColors.darkGrey700}>
        <Close2 />
      </Icon>
    </Button>
  </span>;
export default CategoriesFilterChip;